/**
 *
 * @file 公共接口
 *
 **/

import AXIOS from '@/utils/$axios';
// 获取省市区信息
export const getAreas = data => AXIOS.post('/lws/common/get-region', data);

// 获取区域详情
export const queryAreaDetail = data => AXIOS.post('/lws/common/get-city', data);

// 根据省市区，查询小区
export const queryEstate = payload => {
    return AXIOS.post('/space/common/district-hose', payload);
};
// 上传
export const uploadFile = data =>
    AXIOS.post('/space/common/upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data;charset=UTF-8',
        },
    });
// 查询图片原始文件地址
export const commentAdjunctView = data =>
    AXIOS.post('/space/project/project-drawing/comment-adjunct-view', data);
